import { render, staticRenderFns } from "./SafetySocialTips.vue?vue&type=template&id=38dea9b0&scoped=true&"
import script from "./SafetySocialTips.vue?vue&type=script&lang=js&"
export * from "./SafetySocialTips.vue?vue&type=script&lang=js&"
import style0 from "./SafetySocialTips.vue?vue&type=style&index=0&id=38dea9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dea9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dea9b0')) {
      api.createRecord('38dea9b0', component.options)
    } else {
      api.reload('38dea9b0', component.options)
    }
    module.hot.accept("./SafetySocialTips.vue?vue&type=template&id=38dea9b0&scoped=true&", function () {
      api.rerender('38dea9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/SafetySocialTips.vue"
export default component.exports